import { CE } from './ce';

export class ES extends CE {}
